import React from "react";

import {
  FaFacebookF,
  FaTelegramPlane,
  FaInstagram,
  FaMapMarkerAlt,
} from "react-icons/fa";

import { FaXTwitter } from "react-icons/fa6";
export default function Footer2() {
  return (
    <div>
      <footer style={{ padding: '60px 0 20px', background: '#fdfdfd', borderTop: '1px solid rgba(0,0,0,0.05)' }}>
        <div className="container text-center">
          <div className="footer d-flex justify-content-center" >
            <div className="footer-main">
              <div className="footer-logo mt-2 mb-0">
                <img
                  src="assets/images/img/agn_dark_logo.svg"
                  style={{ width: "150px" }}
                  className="img-fluid"
                  alt="logo"
                />
              </div>
              <div className="agn-footer-info mt-3">
                <h4 className="text-black" style={{
                  fontFamily: 'var(--font-primary)',
                  fontSize: '1.25rem',
                  fontWeight: '800',
                  marginBottom: '15px'
                }}>
                  Empowering Financial Growth Through Smart Systems

                </h4>
                <p className="mt-2 text-black" style={{
                  fontFamily: 'var(--font-secondary)',
                  fontSize: 'var(--small-size)',
                  fontWeight: '600',
                  opacity: 0.8
                }}>
                  AGN is designed to bridge the gap between:

                </p>
                <div className="d-flex justify-content-center gap-3 flex-wrap" style={{
                  fontFamily: 'var(--font-secondary)',
                  fontSize: 'var(--small-size)',
                  fontWeight: '500',
                  color: '#444'
                }}>
                  <span>• Traditional finance
                  </span>
                  <span>• Modern trading systems
                  </span>
                  <span>• Network-driven scalability</span>
                </div>
                <div className="d-flex justify-content-center gap-4 mt-3" style={{
                  fontFamily: 'var(--font-primary)',
                  fontSize: '0.8rem',
                  fontWeight: '800',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  color: 'var(--theme-color)'
                }}>
                  <span>✔ Secure</span>
                  <span>✔ Structured</span>
                  <span>✔ Scalable</span>
                </div>
              </div>

              <ul className="social-links mt-4" style={{ justifyContent: "center" }}>
                <li>
                  <a data-cursor="pointer" href="#">
                    <FaFacebookF className="social-icon" />
                  </a>
                </li>

                <li>
                  <a data-cursor="pointer" href="#">
                    <FaTelegramPlane className="social-icon" />
                  </a>
                </li>

                <li>
                  <a data-cursor="pointer" href="#">
                    <FaInstagram className="social-icon" />
                  </a>
                </li>

                <li>
                  <a data-cursor="pointer" href="#">
                    <FaXTwitter className="social-icon" />
                  </a>
                </li>
              </ul>

              <div className="d-flex align-items-center justify-content-center gap-2 mt-4 text-black" style={{
                fontFamily: 'var(--font-secondary)',
                fontSize: 'var(--small-size)',
                fontWeight: '600',
                opacity: 0.8,
                lineHeight: '1.6',
                background: 'rgba(0, 0, 0, 0.02)',
                padding: '10px 20px',
                borderRadius: '30px',
                border: '1px solid rgba(0, 0, 0, 0.05)',
                display: 'inline-flex',
                maxWidth: '100%'
              }}>
                <FaMapMarkerAlt style={{ color: 'var(--theme-color)', fontSize: '1.1rem', flexShrink: 0 }} />
                <span>118/119 Lakeside view, 11880 highway 67, San diego, USA -CA-92040</span>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column align-items-center mt-5 pt-4 pb-2" style={{ borderTop: "1px solid rgba(0,0,0,0.05)" }}>
            <div className="d-flex justify-content-center align-items-center gap-3 mb-2" style={{ fontFamily: 'var(--font-secondary)', fontWeight: '600' }}>
              <a href="/terms-conditions" style={{ color: "var(--theme-color)", textDecoration: "none", fontSize: "14px" }}>Terms and condition</a>
              <span style={{ color: "#ddd" }}>|</span>
              <a href="/privacy-policy" style={{ color: "var(--theme-color)", textDecoration: "none", fontSize: "14px" }}>Privacy policy</a>
            </div>
            <span style={{
              fontFamily: 'var(--font-secondary)',
              color: "#888",
              fontSize: "13px",
              marginBottom: "0"
            }}>
              © {new Date().getFullYear()} AGN - Adonai Group of Network. All Rights Reserved.
            </span>
          </div>
        </div>
      </footer>
    </div >
  );
}
